import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";

interface ProductImagesCarouselCardProps {
  images?: string[];
}

export const ProductImagesCarouselCard = ({ images }: ProductImagesCarouselCardProps) => {
  const reservedImages = ["/ni.webp", "/hu.webp", "/ya.webp"];

  return (
    <Card className="p-4">
      <CardHeader>
        <CardTitle>Изображения карточки</CardTitle>
      </CardHeader>
      <CardContent className="flex items-center justify-center">
        <Carousel
          opts={{
            align: "start",
          }}
          className="w-full max-w-sm"
        >
          <CarouselContent>
            {images && images.length > 0
              ? images.map((image, index) => (
                  <CarouselItem
                    key={index}
                    className="md:basis-1/2 lg:basis-1/3 flex justify-center items-center aspect-square"
                  >
                    <img src={image} alt={image} />
                  </CarouselItem>
                ))
              : reservedImages.map((image, index) => (
                  <CarouselItem
                    key={index}
                    className="md:basis-1/2 lg:basis-1/3 flex justify-center items-center aspect-square"
                  >
                    <img src={image} alt={image} />
                  </CarouselItem>
                ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </CardContent>
    </Card>
  );
};
